import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { quotationsPageDef } from '@/components/scm/scm-page-defs';

export default function ScmQuotationsPage() {
  return <ScmPageRenderer pageDef={quotationsPageDef} />;
}
